export default __webpack_public_path__ + "static/media/img-abo.ba2e3a94.png";